module.exports = "<div class=modal tabindex=-1 role=dialog> <div class=modal-dialog> <div class=\"modal-content panel-success\"> <div class=\"modal-header panel-heading\"> <button type=button class=close ng-click=$hide()>&times;</button> <h4 class=modal-title><i class=\"fa fa-check\"></i> {{'admin.creation_success_title' | translate}}</h4> </div> <div class=modal-body>{{'admin.creation_success' | translate}}</div> <div class=modal-footer> <button type=button class=\"btn btn-default\" ng-click=$hide()>Ok</button> </div> </div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/users/create/success.modal.tpl.html
 ** module id = 154
 ** module chunks = 0
 **/